import { render } from "./AvailabilitySettings.vue?vue&type=template&id=310c367c&ts=true"
import script from "./AvailabilitySettings.vue?vue&type=script&lang=ts"
export * from "./AvailabilitySettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__